/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * DynamicCloud Backstage API V1
 * API Backstage
 * OpenAPI spec version: v1
 */

export type EntityScope = typeof EntityScope[keyof typeof EntityScope];


export const EntityScope = {
  GLOBAL: 'GLOBAL',
  TEAM: 'TEAM',
} as const;
